import cn from 'classnames';

export enum AlertVariants {
  Error = 'error',
  Info = 'info',
  Success = 'success',
}

export enum AlertSize {
  Small = 'small',
  Medium = 'medium',
}

interface BlockAlertProps {
  children: React.ReactNode;
  variant: AlertVariants;
  size?: AlertSize;
}

export const BlockAlert = ({
  children,
  variant,
  size = AlertSize.Small,
}: BlockAlertProps) => {
  return (
    <div
      className={cn('w-full rounded-md border', {
        'bg-red-100 border-red-200 text-red-700':
          variant === AlertVariants.Error,
        'bg-newTeal-50 border-newTeal-300 text-newTeal-800':
          variant === AlertVariants.Info,
        'bg-lime-100 border-lime-200 text-lime-700':
          variant === AlertVariants.Success,
        'p-2 text-sm': size === AlertSize.Small,
        'p-4': size === AlertSize.Medium,
      })}
    >
      {children}
    </div>
  );
};
